import {GusReportType} from "@src/types/global.types";
import {client as clientAxios} from "@src/library/axios.library";
import {AxiosResponse} from "axios";

export const fetchFromGus = async (nip: string) => {
    const {data} = await clientAxios.get<never, AxiosResponse<GusReportType>>(`api/v1/tools/gus?nip=${nip}`);
    return data;
}
